import React from "react";
import Modal from "react-bootstrap/Modal";
import BtnLoad from "../common/BtnLoad";

const DeleteTaskModal = ({ show, handleClose, onConfirm, loading = false }) => {
  const closeModal = () => {
    if (typeof handleClose === "function") handleClose();
  };

  const handleDelete = async () => {
    if (typeof onConfirm === "function") await onConfirm();
  };

  return (
    <Modal show={show} centered onHide={closeModal} className="createModal">
      <div className="customModalHead">
        <h6>Delete Task</h6>
      </div>
      <Modal.Body>
        <div className="projectCreation">
          <p>Are you sure you want to delete this task?</p>
        </div>
      </Modal.Body>
      <div className="modalFooterB">
        <button className="cancel" onClick={closeModal}>
          Close
        </button>
        <button className="save" onClick={handleDelete}>
          {loading ? <BtnLoad /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteTaskModal;


